import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';


export interface IChangeExtractToLiveActionOnDatasourcesParams extends IMultipleIdsParams {
  workbookId: string;
}

export class ChangeExtractToLiveActionOnDatasourcesRequest extends Request<IChangeExtractToLiveActionOnDatasourcesParams, IResult> {
  constructor(dataSourceIds: string[], workbookId: string) {
    super('changeExtractToLiveActionOnDatasources', {
      ids: dataSourceIds,
      workbookId: workbookId
    });
  }
}
